"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useTimeout;
const react_1 = require("react");
/**
 * A custom hook to execute a function at a given timeout
 * @param fn Function to execute at a timeout
 * @param timeout timeout in milliseconds
 * @param dependencies Optional array of dependencies for the underlying effect that will execute timed out function
 */
function useTimeout(fn, timeout, dependencies) {
    (0, react_1.useEffect)(() => {
        const id = setTimeout(fn, timeout);
        return () => {
            clearTimeout(id);
        };
    }, dependencies);
}
